import { render } from "./activity.vue?vue&type=template&id=b4023b4c&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"

import "./activity.vue?vue&type=style&index=0&id=b4023b4c&lang=scss&scoped=true"
import "./activity.vue?vue&type=style&index=1&id=b4023b4c&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4023b4c"]])

export default __exports__